import React from 'react';  
import ContactForm from '../components/ContactForm';  

const Contacto = () => {  
  return (  
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-rose-100">  
      <ContactForm />  
    </div>  
  );  
};  

export default Contacto;